import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1700Component } from './kymw1700.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1704Module } from '../kymw1704/kymw1704.module';
import { KYMW1705Module } from '../kymw1705/kymw1705.module';
import { KYMW1706Module } from '../kymw1706/kymw1706.module';
import { KYMW1707Module } from '../kymw1707/kymw1707.module';
import { KYMW1708Module } from '../kymw1708/kymw1708.module';
import { KYMW1709Module } from '../kymw1709/kymw1709.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { KYMW0B00Module } from '../../../commons/kymw0b/kymw0b00/kymw0b00.module';
import { KYMW0C00Module } from '../../../commons/kymw0c/kymw0c00/kymw0c00.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { DeleteImageInfoService } from './api-services/delete-image-info.service';
import { GetImageInfoService } from './api-services/get-image-info.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GetOrderListService } from 'src/app/commons/kymw02/api-services/get-order-list.service';
import { UpdateImageKindService } from './api-services/update-image-kind.service';
import { GetOrderingOutputService } from './api-services/get-ordering-output.service';
import { GetPhotoContentsListOutputService } from './api-services/get-photo-contents-list-output.service';
import { GetReferenceImageOutputService } from './api-services/get-reference-image-output.service';
import { GetSampleOrderingOutputService } from './api-services/get-sample-ordering-output.service';
import { UpdateC2pfStatusService } from './api-services/update-c2pf-status.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { FormsModule } from '@angular/forms';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';

/**
 * 画像作成管理画面 モジュール設定クラス
 *
 * @export SampleWindowModule
 * @class SampleWindowModule
 */
@NgModule({
  imports: [
    FormsModule,
    WjInputModule,
    CommonModule,
    PlessSharedModule,
    KYMW0B00Module,
    KYMW0C00Module,
    KYMW1704Module,
    KYMW1705Module,
    KYMW1706Module,
    KYMW1707Module,
    KYMW1708Module,
    KYMW1709Module,
    WjNavModule,
    WjGridModule,
    WjGridFilterModule,
    AppCommonsModule,
    FontAwesomeModule
  ],
  declarations: [
    KYMW1700Component,
  ],
  providers: [
    GetCodeListService,
    DeleteImageInfoService,
    GetImageInfoService,
    GetOrderListService,
    GetOrderingOutputService,
    GetPhotoContentsListOutputService,
    GetReferenceImageOutputService,
    GetSampleOrderingOutputService,
    UpdateC2pfStatusService,
    UpdateImageInfoService,
    UpdateImageKindService
  ],
})
export class KYMW1700Module { }
